<template>
    <div>
         <vs-popup
        :title="$t('assign_client')"
        :active.sync="activeSync"
      >
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-xs="12"
            vs-sm="12"
            vs-lg="12"
          >
            <label>{{ $t('pay_date') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="12"
            vs-lg="12"
          >
         <select
              v-model="selectedValue"
              class="w-full vs-inputx vs-input--input"
            >
              <option
                v-for="(option, i) in selectOptions"
                :key="i"
                :value="option.ClientId"
              >
                {{ option.ClientName }}
              </option>
            </select>
          </vs-col>
        </vs-row>
         <vs-row vs-justify="flex-end" vs-align="center" vs-w="12" class="mt-4">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="primary"
              type="filled"
              class="w-full"

              >{{ $t('save') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>
    </div>
</template>

<script>
export default {
    props:{
        active:{
            type:Boolean,
            default: false
        },
        selectOptions:{
            type:Object,
            default: () => {}
        }
    },
    data() {
        return {
            selectedValue:'',
            //activeSync:false
        }
    },
    computed:{
        activeSync(){
            return this.active
        }
    },
    /* watch:{
        active(val){
            console.log(val);
            //this.activeSync=val
        }
    } */
}
</script>